import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { isOnline, addNetworkListeners } from "../../utils/networkCheck";

const OfflineModal = ({ open, onClose }) => {
  const [offline, setOffline] = useState(!isOnline());

  useEffect(() => {
    return addNetworkListeners({
      onOnline: () => setOffline(false),
      onOffline: () => setOffline(true),
    });
  }, []);

  // Close the modal automatically on internet availability.
  // useEffect(() => {
  //   if (!offline) {
  //     onClose();
  //   }
  // }, [offline, onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1,
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Box
          sx={{
            textAlign: "center",
            py: 3,
            px: 2,
          }}
        >
          {/* Temporary disconnected-wires illustration */}
          <Box
            sx={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              mx: "auto",
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFF3E0",
            }}
          >
            <WifiOffIcon
              sx={{
                fontSize: 52,
                color: "#F57C00",
              }}
            />
          </Box>

          <Typography
            variant="h5"
            fontWeight={700}
            gutterBottom
          >
            You're Offline
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              maxWidth: 300,
              mx: "auto",
              lineHeight: 1.7,
            }}
          >
            This module requires an active internet connection.
            Please reconnect to continue.
          </Typography>

          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              mt: 3,
              borderRadius: 2,
              px: 4,
            }}
          >
            Okay
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default OfflineModal;